<script lang="ts">
    import { onMount, onDestroy } from "svelte";
    import { luhnValid } from "../luhn";
    import { createEventDispatcher } from "svelte";
    import { Html5Qrcode, Html5QrcodeCameraScanConfig } from "html5-qrcode";
    import Icon from "./Icon.svelte";

    const dispatch = createEventDispatcher();

    let qrreader: HTMLDivElement;
    let scanner: Html5Qrcode;
    let error = false;

    export let serial = "";
    export let img = "";

    const onScanSuccess = (text: string) => {
        // if length != 15, we supposed it's a QRCode with Ubiwan's encoding specification
        const imei = text.length == 15 ? text : text.split("/")[0];

        // To prevent unwanted scan, or capture error, we ensure having a valid IMEI
        if (imei.length == 15 && luhnValid(imei)) {
            let video = qrreader.querySelector("video");
            let canvas = document.createElement("canvas");
            canvas.width = video.clientWidth;
            canvas.height = video.clientHeight;

            let ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            img = canvas.toDataURL("image/jpeg");

            scanner.stop();
            serial = imei;
            dispatch("done");
        }
    };

    const scansize = (viewfinderWidth: number, viewfinderHeight: number) => {
        return {
            width: viewfinderWidth * 0.8,
            height: (viewfinderWidth * 0.8 * 3) / 4,
        };
    };

    const config: Html5QrcodeCameraScanConfig = {
        fps: 10,
        qrbox: scansize,
    };

    onMount(() => {
        scanner = new Html5Qrcode(qrreader.id);
        scanner
            .start(
                { facingMode: "environment" },
                config,
                onScanSuccess,
                undefined,
            )
            .then(undefined, () => {
                error = true;
            });
    });

    onDestroy(() => {
        if (scanner.isScanning) scanner.stop();
    });
</script>

<main>
    <!-- Make a random div id, as html5qrcode lib need some -->
    <div id="qrr123456789" bind:this={qrreader}>
        {#if error}
            <div>
                <Icon icon="exclamation-circle-fill" />
                <br />
                La permission d'accès à la caméra a été refusée, vous devez saisir
                manuellement le numéro IMEI
            </div>
        {/if}
    </div>
</main>

<style>
    #qrr123456789 div {
        text-align: center;
        color: crimson;
        font-size: x-large;
    }
</style>
